import { ICurriculumItemableSearchResult } from 'holberton-school-intranet-api';

import { get } from '../../../../api/utils';

interface ICurriculumItemablesResponse {
    projects?: {
        items: ICurriculumItemableSearchResult[];
        next?: string;
    };
}

export interface ICurriculumItemablesPage {
    items: ICurriculumItemableSearchResult[];
    loadMoreURI?: string;
}

export async function fetchCurriculumItemables(
    uri: string,
    csrfToken: string,
): Promise<ICurriculumItemablesPage> {
    const response = await get<ICurriculumItemablesResponse>(uri, csrfToken);

    return {
        items: response.projects?.items ?? [],
        loadMoreURI: response.projects?.next,
    };
}

export function buildCurriculumItemablesURI(
    searchURI: string,
    options: { limit?: number; offset?: number; q?: string } = {},
): string {
    const params = new URLSearchParams();

    if (options.limit !== undefined) {
        params.set('limit', String(options.limit));
    }
    if (options.offset !== undefined) {
        params.set('offset', String(options.offset));
    }
    if (options.q) {
        params.set('q', options.q);
    }

    const query = params.toString();
    if (!query) {
        return searchURI;
    }

    const separator = searchURI.includes('?') ? '&' : '?';
    return `${searchURI}${separator}${query}`;
}
